//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import featureDialog from "./FeatureDialog.vue";

export default {
  computed: {
    ...mapGetters(["getUser"]),
  },
  methods: {
    ...mapActions([
      "changeUserPassword",
      "changeUserEmail",
      "setFBToken",
      "setUserSettings",
    ]),
    showAddFeatureDialog() {
      this.$q.dialog({
        component: featureDialog,
        root: this,
      });
    },
  },
};
